import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoTableColumn } from '@po-ui/ng-components';
import { AuthService } from 'src/app/service/auth.service';
import { defaultRomaneioDto, defaultRomaneioItem, RomaneioDto, RomaneioItem } from '../interface/romaneio';
import { RomaneioService } from '../service/romaneio.service';

@Component({
  selector: 'app-romaneio-cadastro',
  templateUrl: './romaneio-cadastro.component.html',
  styleUrls: ['./romaneio-cadastro.component.css']
})
export class RomaneioCadastroComponent implements OnInit {

  etiqueta: string = '';
  codigoRomaneio: string = '';
  apareceInformacoes: boolean = false;

  romaneio: RomaneioDto;
  labelSalvarFinalizar: string = 'Salvar';
  soSalvar: boolean = true;

  nEtiquetas: number = 0;

  constructor(
    private romaneioService: RomaneioService,
    private route: ActivatedRoute,
    private poDialogService: PoDialogService,
    private router: Router,
    private poNotificationService: PoNotificationService,
    private authService: AuthService,
  ) {
    this.romaneio = defaultRomaneioDto();
  }

  @ViewChild('salvarRomaneioModal', { static: true }) salvarRomaneioModal!: PoModalComponent;

  ngOnInit(): void {

    this.route.params.subscribe((params) => {
      this.authService.validaPrivilegio(["PO_ROMANEIO_PESAGEM"]).then((ret) => {
        this.soSalvar = !ret;
      });

      if ('CZ00COD' in params) {
        this.codigoRomaneio = params['CZ00COD'];

        this.romaneioService.getObjectByValue(this.codigoRomaneio).subscribe(romaneio => {
          this.romaneio = romaneio;
          if (this.romaneio.CZ00STATUS == 'A' || this.romaneio.CZ00STATUS == '0') {
            this.romaneio.items = this.romaneio.items.map((item) => {
                return {...item, favorite: ['delete']};
            });
          }
        }, (e) => {
          this.poDialogService.alert({
            title: 'ATENÇÃO',
            message: 'Romaneio Inválido.',
            ok: () => this.goTo()
          });

        });
      }
    });
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Romaneio', action: this.goTo.bind(this) },
      { label: 'Lista', action: this.goToLista.bind(this) },
      { label: 'Editar Romaneio' }
    ]
  };

  goTo(): void {
    this.router.navigateByUrl('');
  }

  goToLista(): void {
    this.router.navigateByUrl('/estoque/romaneio/lista');
  }

  public readonly colunas: Array<PoTableColumn> = [
    { property: 'CZ01ETIQ', visible: true, label: 'Etiqueta' },
    { property: 'CB1COD', visible: false, label: 'Produto' },
    { property: 'CB1DESC', visible: true, label: 'Descrição' },
    { property: 'NZ01QUANT', visible: true, label: 'Quantidade' },
    {
      property: 'favorite',
      label: '...',
      type: 'icon',
      width: '10%',
      icons: [
        {
          action: this.excluirItem.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Excluir Item do Romaneio',
          value: 'delete',
          disabled: this.deleteDisabled.bind(this)
        },
      ]
    },
  ];

  excluirItem(row: RomaneioItem): void {
    this.romaneioService.removerEtiqueta(this.codigoRomaneio, row.CZ01ETIQ).subscribe((ret) => {
      this.romaneio.items = this.romaneio.items.filter((item) => {
        return item.CZ01ETIQ != row.CZ01ETIQ;
      });
    });
  }

  modalFinalizarRomaneioOpen(): void {
    if (this.romaneio.CZ00STATUS == 'A') {
      this.salvarRomaneioModal.open();
    } else {
      if (this.soSalvar) {
        this.poNotificationService.success("Romaneio salvo com sucesso!");
        this.router.navigateByUrl('/estoque/romaneio/lista');
      } else {
        this.poDialogService.confirm({
          title: 'Enviar Romaneio',
          message: 'Deseja realmente finalizar o Romaneio e enviar a mercadoria?',
          confirm: () => this.avancarRomaneio()
        });
      }
    }
  }

  getPDFRomaneio(): void {
    this.romaneioService.getPdfRomaneio(this.codigoRomaneio).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `ROMANEIO_${this.codigoRomaneio}_${new Date().toLocaleString()}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  }

  avancarRomaneio(): void {
    this.romaneioService.avancarRomaneio(this.codigoRomaneio).subscribe((ret) => {
      this.getPDFRomaneio();
      this.poNotificationService.success("Romaneio enviado com sucesso!");
      this.router.navigateByUrl('/estoque/romaneio/lista');
    });
  }

  biparEtiqueta(): void {
    if (this.etiqueta != '') {
      let etiq = this.etiqueta;
      if (etiq.length > 7 && etiq.substring(0,3) == "000") {
        etiq = etiq.substring(3,etiq.length);
      }
      this.romaneioService.biparEtiqueta(this.codigoRomaneio, etiq).subscribe((ret) => {
        let defaultItem = defaultRomaneioItem();
        this.romaneio.items.push({...defaultItem, CZ01ETIQ: etiq, CB1COD: ret.CB1COD, CB1DESC: ret.CB1DESC, NZ01QUANT: ret.NZ01QUANT, favorite: ['delete']});
      });
      this.etiqueta = '';
    }
  }

  clickInformacoes(): void {
    this.apareceInformacoes = !this.apareceInformacoes;
  }

  confirmarAvancarRomaneio(): void {
    if (this.nEtiquetas == this.romaneio.items.length) {
      this.romaneioService.avancarRomaneio(this.codigoRomaneio).subscribe((ret) => {
        this.poNotificationService.success("Romaneio enviado para o setor de emissão de nota.");
        this.router.navigateByUrl('/estoque/romaneio/lista');
      });
    } else {
      this.poNotificationService.error("O Número de etiquetas bipado não corresponde ao número de etiquetas informado.");
    }
  }

  confirmarSalvarRomaneio(): void {
    this.poNotificationService.success("Romaneio salvo com sucesso!");
    this.router.navigateByUrl('/estoque/romaneio/lista');
  }

  deleteDisabled(): boolean {
    return (this.romaneio.CZ00STATUS == '0' && this.soSalvar)
  }

}
